import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Barcode.svg",
  "use": "Barcode.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Barcode.svg\"><path d=\"M54.0208,18.0208v28a2,2,0,1,1-4,0v-28a2,2,0,1,1,4,0Zm-8-2a2,2,0,0,1,2,2v28a2,2,0,0,1-2,2h-2a2,2,0,0,1-2-2v-28a2,2,0,0,1,2-2Zm-10,0a2,2,0,0,1,2,2v28a2,2,0,0,1-2,2h-1a2,2,0,0,1-2-2v-28a2,2,0,0,1,2-2Zm-5,2v28a2,2,0,1,1-4,0v-28a2,2,0,1,1,4,0Zm-9,0v28a2,2,0,1,1-4,0v-28a2,2,0,1,1,4,0Zm-8-2a2,2,0,0,1,2,2v28a2,2,0,0,1-2,2h-2a2,2,0,0,1-2-2v-28a2,2,0,0,1,2-2Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol